const C = require("../constants");

const paymentsDialog = (data) => {
    return {
        type: C.PAYMENTS_DIALOG,
        data
    }
};

export {paymentsDialog};


// WEBPACK FOOTER //
// ./src/actions/PaymentsDialogActions.js